import { Gondor } from "../Gondor";

const ACTIONS = {
  COST: "/campaign-cost",
};

export function cost(params?: object) {
  return Gondor.API.get(ACTIONS.COST, { params });
}
